import { axiosInstance } from './axios-instance';
import { PAGE_SIZE } from '../magic-values';
import type { PaginationDto } from '../types/common';
import type {
  IntegrationInstallation,
  ListIntegrationInstallationsResponse,
} from '../types/integration-installation';

export interface IntegrationInstallationsFilters {
  accountId: string;
  filterBy?: string;
}

export class IntegrationInstallationService {
  static async getInstallations(
    filters: IntegrationInstallationsFilters,
    pagination?: PaginationDto,
  ): Promise<ListIntegrationInstallationsResponse> {
    const res = await axiosInstance.get<ListIntegrationInstallationsResponse>(
      '/admin/integration-installations',
      { params: { pageSize: PAGE_SIZE, ...pagination, ...filters } },
    );
    return res.data;
  }

  static async getInstallation(id: string, accountId: string): Promise<IntegrationInstallation> {
    const res = await axiosInstance.get<IntegrationInstallation>(
      `/admin/integration-installations/${id}`,
      { params: { accountId } },
    );
    return res.data;
  }
}
